import intlTelInput from 'intl-tel-input';
import '../../../../node_modules/intl-tel-input/build/js/utils';

const SELECTORS = {
	phoneEl: '.phone-country-code',
	phoneElErrorMsg: '.phone-country-code--error',
};

export class PhoneCountryCode {
	constructor() {
		this.phoneEl = document.querySelector(SELECTORS.phoneEl);
		this.phoneElErrorMsg = document.querySelector(SELECTORS.phoneElErrorMsg);

		const requiredElements = [this.phoneEl, this.phoneElErrorMsg];

		if (requiredElements.some((el) => !el)) {
			return;
		}

		this.bindEvents();
		this.setup();
	}

	/**
	 * Explicitly bind `this` for events.
	 * @private
	 */
	bindEvents() {
		['reset'].forEach((e) => {
			this[e] = this[e].bind(this);
		});
	}

	static init() {
		// eslint-disable-next-line
		new PhoneCountryCode();
	}

	reset() {
		this.phoneEl.classList.remove('error');
		this.phoneElErrorMsg.textContent = '';
		this.phoneElErrorMsg.classList.add('hide');
	}

	setupInput() {
		const iti = intlTelInput(this.phoneEl, {
			autoPlaceholder: 'aggressive',
			nationalMode: true,
			initialCountry: 'auto',
			geoIpLookup: (callback) =>
				fetch('https://ipapi.co/json')
					.then((res) => res.json())
					.then((data) => callback(data.country_code))
					.catch(() => callback('gb')),
			hiddenInput: 'international',
			localizedCountries: window.localizedCountries,
			preferredCountries: [],
		});

		// on blur: validate
		this.phoneEl.addEventListener('blur', () => {
			this.reset();
			if (this.phoneEl.value.trim()) {
				if (!iti.isValidNumber()) {
					this.phoneEl.classList.add('error');
					const errorCode = iti.getValidationError();
					this.phoneElErrorMsg.innerHTML = window.errorMap[errorCode];
					this.phoneElErrorMsg.classList.remove('hide');
				}
			}
		});
	}

	setupEventListeners() {
		// on keyup / change flag: reset
		this.phoneEl.addEventListener('change', this.reset);
		this.phoneEl.addEventListener('keyup', this.reset);
	}

	setup() {
		this.setupEventListeners();
		this.setupInput();
	}
}
